import { OpsSeverity } from '@navio/nsdk';
import { isSignalOverdue } from './kinds';
import type { OpsSignal } from './opsSignal';

const SEVERITY_RANK: Record<OpsSeverity, number> = {
  [OpsSeverity.CRITICAL]: 1,
  [OpsSeverity.HIGH]: 2,
  [OpsSeverity.MEDIUM]: 3,
  [OpsSeverity.LOW]: 4
};

const impact = (signal: OpsSignal): number =>
  signal.impactAt ? new Date(signal.impactAt).getTime() : Number.POSITIVE_INFINITY;

const urgencyRank = (signal: OpsSignal, now: Date): number =>
  isSignalOverdue(signal, now) ? 0 : SEVERITY_RANK[signal.severity];

// Each kind is its own request. Sort the merged set, or a late Critical stays behind Medium.
export const compareSignals = (a: OpsSignal, b: OpsSignal, now: Date): number => {
  const byUrgency: number = urgencyRank(a, now) - urgencyRank(b, now);
  const byImpact: number = impact(a) - impact(b);
  const keys: number[] = [byUrgency, byImpact];
  return keys.find((key) => key !== 0 && !Number.isNaN(key)) ?? a.key.localeCompare(b.key);
};
